export default function Opposites() {
  return (
    <p className="z-50 p-10 text-center text-2xl font-light text-neutral-300 w-full bg-neutral-900 leadind-loose tracking-wide">
      Looking ahead, Amadeus is thrilled to announce his
      expansion into the UAE, KSA and Qatar, where he aims
      to develop a vibrant community of beauty
      professionals, His commitment to excellence will guide
      this chapter as he continues to inspire and shape the
      future of beauty education.
    </p>
  );
}
